import { createTypes, completeTypes, withPostSuccess } from 'redux-recompose';

import { createTask, deleteTask, getTasks, getWorkspaceTasks, updateTask } from '#services/TasksService';

import { TARGETS } from './constants';
import { postCheckoutInjections } from './models';

export const actions = createTypes(
  completeTypes(['GET_TASKS', 'CREATE_TASK', 'UPDATE_TASK', 'DELETE_TASK', 'GET_WORKSPACE_TASKS'], []),
  '@@TASKS'
);

// TasksService ya devuelve los datos "desenvueltos" (o lanza un error) para poder
// usarse con React Query. redux-recompose en cambio espera que el service resuelva
// siempre con la forma { ok, data/problem } para decidir si la acción fue un éxito
// o un error, así que acá adaptamos esa respuesta.
const toReduxRecomposeResponse = servicePromise =>
  servicePromise.then(data => ({ ok: true, data })).catch(error => ({ ok: false, problem: error?.message }));

const actionCreators = {
  getTasks: ({ legalCaseId, ...data }) => ({
    type: actions.GET_TASKS,
    target: TARGETS.SELECTED_TASKS,
    service: payload => toReduxRecomposeResponse(getTasks(payload)),
    payload: { legalCaseId, ...data }
  }),
  createTask: (data, currentUser, currentWorkspace) => ({
    type: actions.CREATE_TASK,
    target: TARGETS.TASK,
    service: payload => toReduxRecomposeResponse(createTask(payload)),
    payload: data,
    injections: postCheckoutInjections(data, currentUser, currentWorkspace)
  }),
  updateTask: ({ id, data }, currentUser, currentWorkspace, oldTask) => ({
    type: actions.UPDATE_TASK,
    target: TARGETS.TASK,
    service: payload => toReduxRecomposeResponse(updateTask(payload)),
    payload: { id, ...data },
    injections: postCheckoutInjections(data, currentUser, currentWorkspace, oldTask)
  }),
  deleteTask: (id, onSuccess) => ({
    type: actions.DELETE_TASK,
    target: TARGETS.DELETE_TASK,
    service: payload => toReduxRecomposeResponse(deleteTask(payload)),
    payload: id,
    injections: [withPostSuccess(onSuccess)]
  }),
  getWorkspaceTasks: data => ({
    type: actions.GET_WORKSPACE_TASKS,
    target: TARGETS.WORKSPACE_TASKS,
    service: payload => toReduxRecomposeResponse(getWorkspaceTasks(payload)),
    payload: data
  })
};

export default actionCreators;
